import { OfferedItemLookup } from './useOfferedItemsDataSource';

export function useGroupedOfferedItems(
  items: OfferedItemLookup[],
  activeCategory: string | null,
) {
  if (!activeCategory) return [];

  const filtered = items.filter((i) => i.category === activeCategory);

  const categoryItems = filtered.filter(
    (i) => !i.subcategory && !i.subcategory2,
  );

  const subGroups = Array.from(
    new Set(filtered.map((i) => i.subcategory || '').filter(Boolean)),
  ).map((sub) => {
    const sub2Groups = Array.from(
      new Set(
        filtered
          .filter((i) => i.subcategory === sub && i.subcategory2)
          .map((i) => i.subcategory2 as string),
      ),
    );
    return { name: sub, subcategories2: sub2Groups };
  });

  return [
    {
      category: activeCategory,
      categoryItems,
      subcategories: subGroups,
    },
  ];
}
